<div class="file-dropzone-wrapper">
	@if (!readonly) {
		<!-- TODO: Neichev D. Fix markup for drop zone file list -->
		<div
			class="file-dropzone"
			(click)="triggerFileInput(fileInput)"
			(dragover)="onDragOver($event)"
			(dragleave)="onDragLeave($event)"
			(drop)="onDrop($event)"
			[class.dragging]="isDragging"
			[ngStyle]="{ width: width + 'px', height: height + 'px' }"
		>
			@if (!fileList.length) {
				@if (!hasImageError) {
					<img
						[src]="defaultImg"
						alt="Product image"
						class="default-preview"
						(error)="hasImageError = true"
					/>
				} @else {
					<span class="display-center">{{ placeholder }}</span>
				}
			} @else {
				<ul class="file-list">
					@for (file of fileList; track file; let i = $index) {
						<li class="file-item">
							<div class="file-preview" *ngIf="type === 'img' && isImage(file)" [title]="file.name">
								<img [src]="getObjectURL(file)" alt="preview" />
							</div>
							<div class="file-name">{{ file.name }}</div>
							<button class="remove-button" (click)="removeFile(i, $event)">&#10006;</button>
						</li>
					}
				</ul>
			}

			<input type="file" (change)="onFileSelected($event)" hidden #fileInput multiple />
		</div>
		@if (readonly && fileList.length) {
			<app-button class="upload-btn" [variant]="buttonVariantEnum.Primary" text="Upload" />
		}
		<ng-content></ng-content>
	} @else {
		<div class="file-dropzone readonly" [ngStyle]="{ width: width + 'px', height: height + 'px' }">
			@if (!hasImageError) {
				<img [src]="defaultImg" alt="Product image" class="default-preview" (error)="hasImageError = true" />
			} @else {
				<span class="display-center">{{ placeholder }}</span>
			}
		</div>
		<ng-content></ng-content>
	}
</div>
